<template>
	<vx-card no-shadow card-border class="mt-2">
		<div class="event-item-content">
			<div class="mr-base flex flex-col items-center justify-center">
				<vs-avatar
					icon-pack="feather"
					icon="icon-calendar"
					size="large"
					:color="active ? 'primary' : 'success'"
					:title="(event.activity_name + ' - ' + fullAddress) | capitalize"
				/>
				<small class="g-label--normal"
					>{{ event.init_hour }} {{ event.init_hour.substr(0, 2) >= 12 ? "pm" : "am" }}</small
				>
			</div>
			<div class="event-item-content--info">
				<h5 class="g-label--normal">{{ event.activity_name | capitalize }}</h5>
				<p class="truncate event-item-content--vp-name" :title="event.visit_point_name | capitalize">
					{{ event.visit_point_name | capitalize }}
				</p>
				<small class="activity-e-time truncate" :title="fullAddress | capitalize"
					>{{ fullAddress | capitalize }}
				</small>
			</div>
		</div>
	</vx-card>
</template>

<script>
import EventProgrammed from "@/models/EventProgrammed.js";

export default {
	props: {
		event: {
			type: Object,
			default: () => new EventProgrammed({}),
		},
		active: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		fullAddress() {
			return this.event.address + " " + this.event.city;
		},
	},
};
</script>
<style lang="scss" scoped>
.event-item-content {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.event-item-content--vp-name {
	width: 90%;
}

.event-item-content--info {
	text-align: start;
	display: block;
	width: 100%;
}

@media only screen and (min-width: 481px) {
	.event-item-content {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.event-item-content--info {
		text-align: center;
		display: block;
	}
}

@media only screen and (min-width: 768px) {
	.event-item-content {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.event-item-content--info {
		text-align: center;
		display: none;
	}
}

@media only screen and (min-width: 1289px) {
	.event-item-content {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.event-item-content--info {
		text-align: start;
		display: block;
	}
}
</style>
